import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TextField } from '@mui/material';
import { InputAdornment, TextFieldProps } from '@mui/material';

type SearchProps = {
  value: string;
  onChange: TextFieldProps['onChange'];
  disabled?: boolean;
  id?: string;
  textFieldProps?: TextFieldProps;
};

export const Search = (props: SearchProps) => {
  return (
    <TextField
      defaultValue={props.value}
      size="small"
      placeholder="Search..."
      id={props.id}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <FontAwesomeIcon icon={faSearch} />
          </InputAdornment>
        ),
      }}
      onChange={e => props.onChange?.(e)}
      disabled={props.disabled}
      {...props.textFieldProps}
    />
  );
};
